import { jsx as e, jsxs as c } from "react/jsx-runtime";
import { clsx as u } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { forwardRef as N } from "react";
import { useEscapeKey as b } from "../../utils/use-escape-key.js";
import { useScrollLock as v } from "../../utils/use-scroll-lock.js";
import { RocheUIIcon as x } from "../icon/roche-icon.js";
import r from "./roche-drawer.module.scss.js";
import { RocheUIDrawerDirection as D } from "./roche-drawer.types.js";
const O = /* @__PURE__ */ N(
  ({
    open: a,
    closing: i = !1,
    direction: t = D.BOTTOM,
    fullSize: d = !1,
    dialogLabel: m,
    closeButtonLabel: n = "Close",
    onClose: o,
    children: w,
    heading: l,
    footer: s,
    ...f
  }, h) => {
    b(o, a), v(a);
    const p = u(
      r.drawer,
      r[`drawer--${t}`],
      d && r["drawer--full-size"],
      a && r["drawer--open"],
      i && r["drawer--closing"]
    );
    return /* @__PURE__ */ e(
      "dialog",
      {
        ref: h,
        className: p,
        "aria-modal": "true",
        "aria-label": m,
        onCancel: (_) => _.preventDefault(),
        ...f,
        children: /* @__PURE__ */ c("div", { className: r.drawer__container, children: [
          /* @__PURE__ */ c("div", { className: r.drawer__header, children: [
            l && /* @__PURE__ */ e("h2", { className: r.drawer__title, children: l }),
            /* @__PURE__ */ e(
              "button",
              {
                type: "button",
                className: r["drawer__close-button"],
                onClick: o,
                "aria-label": n,
                children: /* @__PURE__ */ e(x, { icon: "mobile-close", height: "32px", decorative: !0 })
              }
            )
          ] }),
          /* @__PURE__ */ e("div", { className: r.drawer__content, children: w }),
          s && /* @__PURE__ */ e("div", { className: r.drawer__footer, children: s })
        ] })
      }
    );
  }
);
export {
  O as RocheUIDrawer
};
